import { SectionProps } from '../props/section/section-props';
import { SectionStore } from '../store/section-store';
import { SectionMutationAPI } from '../api/section-mutation-api';
import { DataModel } from './data-model';
import type { IEventManager } from '../manager/event-manager';
import type { IBaseContext } from '../context/base-context';
import type { ISectionData } from '../data';
import type { ISectionProps } from '../props/section/section-props';
import type { RestrictedDataModel } from './data-model';
import type { PresentationDataModel } from './presentation-data-model';

export class SectionDataModel extends DataModel<ISectionData> {
    public context: IBaseContext = {
        getPresentation: () => {
            return this.parent;
        },
        getTarget: () => this,
    };
    public store: SectionStore;
    public props: ISectionProps;
    public api: SectionMutationAPI;

    public constructor(data: ISectionData, events: IEventManager, public parent: PresentationDataModel) {
        super(events);

        this.store = new SectionStore(data, events, this);
        this.props = new SectionProps(this.store.data);
        this.api = new SectionMutationAPI(this, events);
    }
}

export { ISectionProps };
export type ISectionDataModel = RestrictedDataModel<SectionDataModel>;
